import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'lanternGlow',
      d: 'M-0.5,-3.5h0.5v1h-0.5zM-3,-2h1v0.5h-1zM1,-2h1v0.5h-1zM-2.5,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'parasolStripe',
      d: 'M-1,-3.5h0.5v0.5h-0.5zM-3,-2.5h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M1.5,-2.5h0.5v0.5h-0.5z' },
  ],
  pixels: 13,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'lanternGlow',
      d: 'M-3,-4h0.5v1h-0.5zM3,-4h0.5v0.5h-0.5zM0,-3.5h0.5v0.5h-0.5zM-5,-3h1v0.5h-1zM-4.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v1h-0.5z',
    },
    {
      paint: 'parasolStripe',
      d: 'M2.5,-4.5h0.5v0.5h-0.5zM-3.5,-4h0.5v0.5h-0.5zM0,-4h0.5v0.5h-0.5zM-5,-3.5h0.5v0.5h-0.5zM-0.5,-3.5h0.5v0.5h-0.5zM-4,-3h0.5v0.5h-0.5zM1,-3h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM-2,-2.5h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M3,-4.5h0.5v0.5h-0.5zM1.5,-3h0.5v0.5h-0.5z' },
  ],
  pixels: 22,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-0.5,-3.5h1v0.5h-1zM-1,-3h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5zM0.5,0h0.5v0.5h-0.5z',
    },
    { paint: 'poolWater', d: 'M-0.5,-2h1.5v1.5h-1.5zM-1,-0.5h2v0.5h-2z' },
    { paint: 'poolEdge', d: 'M-1,-2h0.5v1.5h-0.5zM-0.5,0h1v0.5h-1z' },
    { paint: 'acornCap', d: 'M-1,-2.5h2v0.5h-2z' },
    { paint: 'nestBrown', d: 'M-0.5,-3h1v0.5h-1z' },
  ],
  pixels: 29,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
